module.exports = __webpack_public_path__ + "img/effect-top-img.588a4e48.png";